module.exports = __webpack_public_path__ + "img/03-B01.5c945443.png";